import React from 'react';

import ProductRating from './product-rating';

import '../../product/css/product-review.less';

const ProductReview = props => {
    let { product, displayAvgRating = false, hideReviewCount } = props;
    const { prdClass } = product;
    let numReviews = `(${product.numReviews})`;
    let rating;
    const isExternalSku = prdClass === 'EXT';
    try{
        rating = product.rating.toFixed(1);
    }catch(e){}
    let content = !isExternalSku ?
        <div className="product-review">
            <ProductRating rating={product.rating} />
            {displayAvgRating && rating ? <span className="avg-rating">{rating}/5</span> : null}
            {!hideReviewCount && <span className="num-reviews">{numReviews}</span>}
        </div> : null;
    return content;
};

export default ProductReview;
